export default {
  contactLoadingStatus: 'notLoading',
  contacts: []
}
